import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";

const CTA = () => {
  return (
    <section className="relative py-24 text-white gpu-accelerate">
      {/* Background with consistent rendering */}
      <div className="absolute inset-0 bg-red-500 -z-10" />
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative">
        <h2 className="text-4xl md:text-5xl font-bold mb-6">
          Redo för ett Skinande Rent Hem?
        </h2>
        <p className="text-xl mb-10 opacity-90">
          Gå med tusentals nöjda kunder som litar på RenGlans för sina städbehov.
          Få en kostnadsfri offert idag!
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <a href="#" className="block" onClick={(e) => { e.preventDefault(); window.scrollTo({ top: 0, behavior: 'smooth' }); }}>
            <Button 
              size="lg"
              className="bg-white text-red-600 hover:bg-gray-100 text-lg px-10 py-7 uppercase font-normal tracking-wide w-full"
            >
              Få Gratis Offert
              <ArrowRight className="ml-2 w-5 h-5" />
            </Button>
          </a>
          <a href="#tjanster" className="block">
            <Button 
              size="lg"
              variant="outline"
              className="bg-transparent border-2 border-white text-white hover:bg-white hover:text-red-600 text-lg px-10 py-7 uppercase font-normal tracking-wide w-full transition-colors duration-200"
            >
              Våra Tjänster
            </Button>
          </a>
        </div>
      </div>
    </section>
  );
};

export default CTA;
